module.exports = __webpack_public_path__ + "static/media/export.b073a318.svg";